// extracted by mini-css-extract-plugin
export default {"template4":"styles_template4__cdSZL"};